import "./AuthCard.css";
import React, { Dispatch, SetStateAction, useState } from "react";
import { authCardData } from "../../data/data";
import { useNavigate } from "react-router-dom";
import { UserData } from "../../routes/AppRoutes";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { setFeatureName } from "../../redux/AuthCardReducer/AuthCardSlice";
import Header from "../../layouts/header/Header";
import { reactIcons } from "../../icons/reactIcons";
import InfoModal from "../../components/reusable-info-modal/InfoModal";
import {
  handleActiveAcademicYear,
  handlePlcAcademicYear,
} from "../../utils/service";

export interface cardProps {
  isAuthenticated: UserData | null;
  setIsAuthenticated: Dispatch<SetStateAction<UserData | null>>;
}

type userRole = {
  id: number;
  displayName: string;
  route: string;
  roles: string;
};

const AuthCard: React.FC<cardProps> = ({
  isAuthenticated,
  setIsAuthenticated,
}) => {
  const dispatcher = useDispatch();
  const { token_details } = useSelector((state: RootState) => state?.Auth);
  const navigate = useNavigate();

  //using the following modal to store the status of infoModal, when active plc acdemic year's found
  const [activeAcademicYearStatus, setActiveAcademicYearStatus] =
    useState<boolean>(false);

  const handleRouteModule = (routeModule: userRole) => {
    // if (
    //   routeModule.route === "/plc" &&
    //   !token_details?.hasActivePlcAcademicYear
    // ) {
    //   setActiveAcademicYearStatus(true);
    // } else {
    dispatcher(setFeatureName(routeModule?.roles));
    localStorage.setItem("oc_all_in_FeatureName", routeModule?.roles);
    navigate(routeModule?.route);
    //}
    handleRenderAcademicYear(routeModule);
  };

  async function handleRenderAcademicYear(routeModule: userRole) {
    await handleActiveAcademicYear(dispatcher);
    // if (routeModule.route === "/plc") {
    //   //await handlePlcAcademicYear(dispatcher);
    // } else {
    //   handleActiveAcademicYear(dispatcher);
    // }
  }

  return (
    <div className="authcard">
      <Header setIsAuthenticated={setIsAuthenticated} />
      <div className="authcard-container">
        <h3 className="authCard-info-text">
          System identified that this user has access to the following modules.
          Please select one to proceed.
        </h3>
        <div className="card-wrapper">
          {authCardData?.map((item: any, i: number) => {
            return token_details?.featureAccess.length === 0 ? (
              <div
                className="card-content"
                key={i}
                onClick={() => handleRouteModule(item)}
              >
                <h3 className="card-title">{item?.displayName}</h3>
                <span>
                  <reactIcons.rightArrow />
                </span>
              </div>
            ) : token_details?.featureAccess.includes(item?.roles) ? (
              <div
                className="card-content"
                key={i}
                onClick={() => handleRouteModule(item)}
              >
                <h3 className="card-title">{item?.displayName}</h3>
                <span>
                  <reactIcons.rightArrow />
                </span>
              </div>
            ) : (
              ""
            );
          })}
        </div>
      </div>
      {/* {activeAcademicYearStatus && (
        <InfoModal onClose={() => setActiveAcademicYearStatus(false)} />
      )} */}
    </div>
  );
};

export default AuthCard;
